import { DataTable, DataTableRowClickEvent, DataTableStateEvent } from "primereact/datatable";
import { useTranslation } from "react-i18next";
import { useNavigate } from "react-router-dom";
import { useAppSelector } from "../../hooks/storeHooks";
import { selectAnswer } from "../../store/selectors/answerSelectors";
import { useCallback, useMemo, useState } from "react";
import { defaultInspectionListColumns, defaultInspectionListFilters } from "../../utils/answerTableHelper";
import { InspectionListTableHeader } from "./InspectionListTableHeader";
import { cloneDeep } from "lodash";
import { Inspection } from "../../types/inspection";
import { DataTableFilterMeta } from "primereact/datatable";

export const InspectionListTable = () => {
    const { t } = useTranslation("locale");
    const navigate = useNavigate();
    const { inspections, loadingInspections } = useAppSelector(selectAnswer);

    const [filters, setFilters] = useState<DataTableFilterMeta>(defaultInspectionListFilters);
    const [globalFilterValue, setGlobalFilterValue] = useState<string>("");

    const onFilter = useCallback((event: DataTableStateEvent) => {
        setFilters(event.filters);
    }, []);

    const onRowClick = useCallback((event: DataTableRowClickEvent) => {
        const inspection = event.data as Inspection;
        const id = (inspection as Record<string, unknown>).inspectionId || inspection.id;
        navigate(`/inspection/answers/${id}`);
    }, [navigate]);

    const renderHeader = useMemo(
        () => <InspectionListTableHeader globalFilterValue={globalFilterValue} setGlobalFilterValue={setGlobalFilterValue} />,
        [globalFilterValue]
    );

    const value = useMemo(() => cloneDeep(inspections), [inspections]);
    const columns = useMemo(() => defaultInspectionListColumns(t), [t]);
    const rowOptions = useMemo(() => [10, 25, 50, 100], []);

    return (
        <DataTable
            value={value}
            dataKey="id"
            loading={loadingInspections}
            filters={filters}
            onFilter={onFilter}
            filterDisplay="row"
            paginator
            scrollable
            removableSort
            stripedRows
            size="small"
            rows={10}
            rowsPerPageOptions={rowOptions}
            header={renderHeader}
            onRowClick={onRowClick}
            rowClassName={() => "cursor-pointer"}
            globalFilterFields={['id', 'vesselName', 'inspectionNumber', 'status']}
        >
            {columns}
        </DataTable>
    );
};
